import { render, staticRenderFns } from "./orderNoPay.vue?vue&type=template&id=13c3c826&scoped=true&"
import script from "./orderNoPay.vue?vue&type=script&lang=js&"
export * from "./orderNoPay.vue?vue&type=script&lang=js&"
import style0 from "./orderNoPay.vue?vue&type=style&index=0&id=13c3c826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3c826",
  null
  
)

export default component.exports